<template>
    <div class="spinner">
        <div class="spinner__dot" :class="{ active: currentDot === 0 }"></div>
        <div class="spinner__dot" :class="{ active: currentDot === 1 }"></div>
        <div class="spinner__dot" :class="{ active: currentDot === 2 }"></div>
    </div>
</template>

<script>
export default {
    name: 'Spinner',
    data() {
        return {
            currentDot: 0,
            intervalId: null
        };
    },
    mounted() {
        this.startSpinner();
    },
    beforeDestroy() {
        this.stopSpinner();
    },
    methods: {
        startSpinner() {
            this.intervalId = setInterval(() => {
                this.currentDot = (this.currentDot + 1) % 3;
            }, 500);
        },
        stopSpinner() {
            clearInterval(this.intervalId);
        }
    }
};
</script>

<style scoped>
.spinner {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 16px;
}

.spinner__dot {
    width: 8px;
    height: 8px;
    background-color: var(--bg-2-fg-1);
    border-radius: 50%;
    margin: 0 5px;
    transition: background-color 0.3s ease;
}

.spinner__dot.active {
    background-color: var(--bg-2-fg-3);
}
</style>
